
import type { SvgIconProps } from "@mui/material"
import { CustomIcon } from "../../../common/Icon/CustonIcon"

export const UsersIcon = (props: SvgIconProps) => (
    <CustomIcon
        svgContent={
            <>
                <circle cx="9" cy="7" r="3" stroke="currentColor" fill="none" strokeWidth="1.5" />
                <path
                    d="M3 18C3 15.5 5.5 13.5 9 13.5C12.5 13.5 15 15.5 15 18"
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="1.5"
                />
                <circle cx="16" cy="9" r="2.5" stroke="currentColor" fill="none" strokeWidth="1.5" />
                <path
                    d="M14 14.5C15 14 16.5 14 18 14.5C19.5 15 21 16.5 21 18"
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="1.5"
                />
            </>
        }
        {...props}
    />
)

